import SectionTitleWidget from './SectionTitleWidget';
import PageTitleWidget from './PageTitleWidget';
import ArticleFeedWidget from './ArticleFeedWidget';
import QuoteWidget from './QuoteWidget';
import TextBoxWidget from './TextBoxWidget';
import HorizontalFeedWidget from './HorizontalFeedWidget';
import AccentWidget from './AccentWidget';
import ImageWidget from './ImageWidget';
import LeadImageWidget from './LeadImageWidget';
import GalleryWidget from './GalleryWidget';
import HtmlWidget from './HtmlWidget';
import VideoWidget from './VideoWidget';
import CtaButtonWidget from './CtaButtonWidget';
import NotesWidget from './NotesWidget';
import AccentImageWidget from './AccentImageWidget';
import FullWidthGalleryWidget from './FullWidthGalleryWidget';

export const WIDGET_LIST = {
  SectionTitleWidget,
  PageTitleWidget,
  ArticleFeedWidget,
  QuoteWidget,
  TextBoxWidget,
  HorizontalFeedWidget,
  AccentWidget,
  ImageWidget,
  LeadImageWidget,
  GalleryWidget,
  HtmlWidget,
  VideoWidget,
  CtaButtonWidget,
  NotesWidget,
  AccentImageWidget,
  FullWidthGalleryWidget,
};
